if (typeof QuickBuy !== 'function') {
	class QuickBuy extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				button: '.button',
				iconButton: '.icon-button',
			};

			this.classes = {
				buttonLoading: 'button--loading',
				iconButton: 'icon-button',
				iconButtonLoading: 'icon-button--loading',
				hasError: 'has-error',
			};

			// Elements
			this.cartDrawer = document.querySelector('drawer-component[data-type="cart"]');
			this.drawer = document.querySelector('drawer-component[data-type="drawer"]');

			this.init();
		}

		initFlags() {
			this.variantId = this.dataset.id;
			this.productUrl = this.dataset.url;
			this.hasVariants = JSON.parse(this.dataset.hasVariants);
		}

		init() {
			const trigger = this;

			this.addEventListener('click', (e) => {
				e.preventDefault();

				this.addToCart(trigger);
			});
		}

		addToCart(trigger) {
			const { cartDrawer, drawer, classes, selectors } = this;
			const button = trigger.querySelector(selectors.iconButton) || trigger.querySelector(selectors.button) || trigger;
			const classToAdd = button.classList.contains(classes.iconButton)
				? classes.iconButtonLoading
				: classes.buttonLoading;

			this.initFlags();

			button.classList.add(classToAdd);
			button.setAttribute('disabled', true);

			if (this.hasVariants) {
				fetch(
					this.productUrl.includes('?')
						? `${this.productUrl}&variant=${this.variantId}&view=quickshop`
						: `${this.productUrl}?variant=${this.variantId}&view=quickshop`
				)
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

						this.productElement = responseHTML.querySelector('section[id^="ProductQuickshop-"]');
						this.preventVariantURLSwitching();

						drawer.replaceDrawerHeading(window.variantStrings.choose_options);
						drawer.replaceDrawerContent(this.productElement.innerHTML);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}
					})
					.finally(() => {
						const imagesReloadEvent = new CustomEvent('lazy-image:reload', {
							bubbles: true,
							detail: this,
						});

						const cartDrawerLoadEvent = new CustomEvent('cart-drawer:load', {
							bubbles: true,
							detail: this,
						});

						document.dispatchEvent(imagesReloadEvent);
						document.dispatchEvent(cartDrawerLoadEvent);

						button.classList.remove(classToAdd);
						button.removeAttribute('disabled');

						drawer.openDrawer('drawer');

						setTimeout(() => {
							trapFocus(drawer);
						}, 100);
					});
			} else {
				const config = fetchConfig('javascript');

				config.headers['X-Requested-With'] = 'XMLHttpRequest';

				delete config.headers['Content-Type'];

				const formData = new FormData();

				formData.append('id', this.variantId);
				formData.append('quantity', 1);

				if (cartDrawer) {
					formData.append(
						'sections',
						drawer.getSectionsToRender().map((section) => section.section)
					);
					formData.append('sections_url', window.location.pathname);
				}

				config.body = formData;

				fetch(`${window.routes.cart_add_url}.js`, config)
					.then((response) => response.json())
					.then((parsedState) => {
						if (cartDrawer) {
							cartDrawer.renderContents(parsedState);
						}

						const cartUpdatedEvent = new CustomEvent('cart:updated', {
							detail: parsedState,
						});

						const imagesReloadEvent = new CustomEvent('lazy-image:reload', {
							bubbles: true,
							detail: this,
						});

						const cartDrawerLoadEvent = new CustomEvent('cart-drawer:load', {
							bubbles: true,
							detail: this,
						});

						document.dispatchEvent(imagesReloadEvent);
						document.dispatchEvent(cartUpdatedEvent);
						document.dispatchEvent(cartDrawerLoadEvent);
					})
					.catch((error) => {
						this.classList.add(classes.hasError);
					})
					.finally(() => {
						button.classList.remove(classToAdd);
						button.removeAttribute('disabled');
					});
			}
		}

		preventVariantURLSwitching() {
			const variantPicker = this.productElement?.querySelector('variant-radios,variant-selects');

			if (!variantPicker) return;

			variantPicker.setAttribute('data-update-url', 'false');
		}
	}

	if (!customElements.get('quick-buy')) {
		customElements.define('quick-buy', QuickBuy);
	}

	class ColorSwatches extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				parent: '.product-item',
				items: '.color-swatches__list-item',
				quickBuy: 'quick-buy',
			};

			this.classes = {
				colorSwatch: 'color-swatches__list-item',
				colorSwatchSelected: 'color-swatches__list-item--selected',
			};

			// Elements
			this.parent = this.closest(this.selectors.parent);
			this.items = this.querySelectorAll(this.selectors.items);
			this.quickBuy = this.parent.querySelector(this.selectors.quickBuy);

			this.init();
		}

		init() {
			this.addEventListeners();
		}

		addEventListeners() {
			const { classes } = this;

			this.addEventListener('click', (e) => {
				e.preventDefault();

				const target = e.target;
				const targetClassList = target.classList;

				if (!targetClassList.contains(classes.colorSwatch)) return;

				this.updateProductItemVariant(target);
			});
		}

		updateProductItemVariant(target) {
			const { quickBuy, classes } = this;

			const variantID = target.dataset.id;

			if (quickBuy) {
				const quickBuyID = quickBuy.getAttribute('id');

				if (quickBuyID != variantID) {
					quickBuy.setAttribute('data-id', variantID);
				}

				this.updateClasses(target);

				quickBuy.click();
			}
		}

		updateClasses(target) {
			const { items, classes } = this;

			items.forEach((item) => {
				item.classList.remove(classes.colorSwatchSelected);
			});

			target.classList.add(classes.colorSwatchSelected);
		}
	}

	if (!customElements.get('color-swatches')) {
		customElements.define('color-swatches', ColorSwatches);
	}
}
